import Header45 from './Header45'
export default Header45
